import type { ComponentPropsWithoutRef } from 'react';
import type { Validation } from '../Table';
import { Error } from './Error';
import { RowsError } from './RowError';

type Props = Pick<
  ComponentPropsWithoutRef<typeof RowsError>,
  'onRangeClick'
> & {
  validation: Validation;
  onDismiss: () => void;
};

export const ValidationError = ({
  validation,
  onDismiss,
  onRangeClick,
}: Props) => {
  return (
    <Error onDismiss={onDismiss}>
      {validation.errorRowRanges ? (
        <RowsError
          message={validation.error ?? ''}
          ranges={validation.errorRowRanges}
          onRangeClick={onRangeClick}
        />
      ) : (
        <>{validation.error}</>
      )}
    </Error>
  );
};
